import { SectionIntro } from '@/app/_components/core/section-intro';
import type { IntroWithAlignment } from '@/entities/models/page';

interface CarouselIntroProps {
  intro: IntroWithAlignment;
  trackingPrefix?: string;
}

export function CarouselIntro({ intro, trackingPrefix }: CarouselIntroProps) {
  return <SectionIntro intro={intro} withMoreLink trackingPrefix={trackingPrefix} />;
}
